import React, { Component } from "react";
import { Switch, Route, Link, BrowserRouter } from "react-router-dom";
import Multiselect from "./multiselect";
import { makeStyles } from "@material-ui/core/styles";
import MiddleHeader from '../middleHeader/middleHeader'
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import Colors from "./../../Global/colors";
import CreateScheduleForm from "./createschedulesearch";
import { useTranslation } from "react-i18next";

export default function CreateSchedule() {
  const { t } = useTranslation();
  return (
    <>
    <MiddleHeader disable={true}/>
    
    <div
      className=""
      style={{width:'100%', marginTop: 0, padding: "20px", overflowY:'auto', backgroundColor:Colors.globalColor9 }}

    >
      <div style={{backgroundColor:'white', borderRadius:'10px',overflow:"hidden",boxShadow:
                  "0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19)"}}>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
        style={{padding: 10}}
      >
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <p style={{ fontSize:'25px',margin:'5px', color:Colors.globalColor8}}>
            <b>{t("Schedule Inspection")}</b>
          </p>
        </Grid>
        {/* <Grid item xs={6} style={{ textAlign: "right" }}>
          <div className="feedback">
            <span>
              <a href="#/"> Send us feedback</a>
            </span>
          </div>
        </Grid> */}
      </Grid>

      <Paper style={{ paddingTop: 10, paddingBottom: 40, backgroundColor:'white' }} elevation={0} >
        <Grid
          container
          spacing={1}
          direction="row"
          justify="center"
          alignItems="center"
          style={{ flexGrow: 1 }}
        >
          <Grid item xs={12}>
            <CreateScheduleForm />
          </Grid>
        </Grid>
      </Paper>
    </div>
    </div>
    </>
  );
}
